import Types from "./Types";

const INIT_STATE = {
  packages: [],
  packageDetails: {},
  items: [],
  availableServices: [],
  availableServicesEventType: null,
  count: 0,
  load: null,
  error: null,
};

export function packagesReducer(state = INIT_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.PACKAGES_LOADING: {
      return {
        ...state,
        load: payload,
      };
    }
    case Types.GET_PACKAGES_SUCCESS: {
      return {
        ...state,
        packages: payload?.data?.packages || [],
        count: payload?.extra?.total_count,
      };
    }
    case Types.GET_PACKAGE_DETAILS_SUCCESS: {
      const pkg = payload?.data?.package || {};
      return {
        ...state,
        packageDetails: pkg,
        items: pkg?.items || state.items,
      };
    }
    case Types.GET_PACKAGE_ITEMS_SUCCESS: {
      return {
        ...state,
        items: payload?.data?.items || [],
      };
    }
    case Types.GET_AVAILABLE_PACKAGE_SERVICES_SUCCESS: {
      return {
        ...state,
        availableServices: payload?.data?.services || [],
        availableServicesEventType: payload?.data?.event_type || null,
      };
    }
    case Types.CLEAR_AVAILABLE_PACKAGE_SERVICES: {
      return {
        ...state,
        availableServices: [],
        availableServicesEventType: null,
      };
    }
    default:
      return state;
  }
}
